<template>
  <el-collapse accordion v-model="activeNames" :class="$.action_group">
    <el-collapse-item name="btnGroup">
      <template slot="title">
        {{title||'操作菜单'}}
        <i class="header-icon el-icon-menu"></i>
      </template>
      <template v-for="(item,index) in actions">
        <el-button
          :key="index"
          type="primary"
          @click="clickHandle(item.emitCallback)"
          :icon="'el-icon-'+item.icon"
        >{{item.name}}</el-button>
      </template>

      <!-- <el-button type="primary" icon="el-icon-search">发送成绩通知</el-button> -->
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: "操作菜单"
    }
  },
  data(){
    return {
      activeNames:''
    }
  },
  methods: {
    clickHandle(callBackHandle, data = {}) {
      console.log("[按钮点击触发事件]:", callBackHandle);
      this.$emit(callBackHandle, data);
    }
  }
};
</script>

<style lang="scss" module="$">
.action_menu {
  display: flex;
}
.action_group{
  :global {
    .el-button {
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      border-radius: 2px;
    }
    .el-collapse-item__wrap {
      padding: 0 30px;
      background-color: ghostwhite;
    }
    .el-collapse-item__header {
      padding-left: 30px;
    }
    .el-collapse-item__content {
      padding-top: 25px;
    }
  }
}
</style>
